import {useParams} from "react-router-dom";
import {resolveServiceDetail, resolveServiceProviders} from "@/services/services.ts";
import {useEffect} from "react";
import {useRecentServices} from "@/hooks/useRecentServices";

import ServiceDashboard from "./ServiceDashboard";
import ErrorBoundary from "@/components/Shared/ErrorBoundary";
import ServiceErrorWindow from "./Utils/ServiceErrorWindow";

import External from "./External";
import Internal from "./Internal";
import {resolveTeamPermissions} from "@/services/team";

// eslint-disable-next-line react-refresh/only-export-components
function Service() {
    const params = useParams();
    const {trackServiceVisit} = useRecentServices();

    const {data: permissions} = resolveTeamPermissions();
    const {data: service} = resolveServiceDetail(params.service_uuid);
    const {data: providers} = resolveServiceProviders();

    // Track service visit when service data is loaded
    useEffect(() => {
        if (service) {
            trackServiceVisit(service);
        }
    }, [service, trackServiceVisit]);

    const context = {
        providers,
        permissions,
        service,
        params,
    };

    switch (service?.provider_scope) {
        case "External.SwiftFederation":
            return <External.SwiftFederation {...context} />;
        case "External.SwiftCoder":
            return <External.SwiftCoder {...context} />;
        case "External.Mlytics":
            return <External.Mlytics {...context} />;
        case "Internal.Minio":
            return <Internal.Minio {...context} />;
        case "Internal.Minio.Managed":
            return <Internal.MinioManaged {...context} />;
        case "Internal.FastChannel":
            return <Internal.FastChannel {...context} />;
        case "Internal.VMware":
            return <Internal.VMware {...context} />;
        case "Internal.VMware.Private":
            return <Internal.VMwarePrivate {...context} />;
        case "Internal.Opennebula":
            return <Internal.Opennebula {...context}/>;
        case "Internal.Opennebula.Kubernetes":
            return <Internal.Kubernetes {...context}/>;
        case "Internal.Influxdb.Report":
            return <Internal.InfluxdbReport {...context}/>;
        case "External.Aliyun.CDN":
            return <External.AliyunCDN {...context} />;
        case "External.Conversant.CDN":
            return <External.ConversantCDN {...context} />;
        case "External.Conversant.Live":
            return <External.ConversantLive {...context} />;
        default:
            return null;
        // nothing to do
    }
}

// eslint-disable-next-line react-refresh/only-export-components
function Router() {
    return (
        <ErrorBoundary component={<ServiceErrorWindow/>}>
            <Service/>
        </ErrorBoundary>
    );
}

export default {
    Router,
    Dashboard: ServiceDashboard,
};
